module.exports = __webpack_public_path__ + "4ccea88b93e494b79bb83eef03e7e8c9.png";